import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { LoadingService } from 'src/app/shared/services/loading.service';

@Component({
    selector: 'app-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss'],
})
export class LoadingComponent implements OnInit {
    showSpinner = true;

    constructor(
        private loadingService: LoadingService,
        private cdRef: ChangeDetectorRef
    ) {}

    ngAfterViewInit(): void {
        this.loadingService.getLoadingStatus().subscribe((data) => {
            this.showSpinner = data;
        });
        this.cdRef.detectChanges();
    }

    ngOnInit(): void {}
}
